var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusiness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "45px",
    viewBox: "0 0 46 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-business",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bank",
    transform: "translate(1.000000, 1.000000)",
    stroke: "#FB9A02",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    points: "22 0 0 12 0 18 44 18 44 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,37 L28,23",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,37 L4,23",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,23 L16,37",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,37 L40,23",
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,9.99999975 C25,11.0717967 24.428203,12.0621776 23.5,12.5980755 C22.571797,13.1339745 21.428203,13.1339745 20.5,12.5980755 C19.571797,12.0621776 19,11.0717967 19,9.99999975 C19,8.92820284 19.571797,7.93782192 20.5,7.40192397 C21.428203,6.86602501 22.571797,6.86602501 23.5,7.40192397 C24.428203,7.93782192 25,8.92820284 25,9.99999975 Z",
    id: "Stroke-11"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-13",
    points: "0 37 44 37 44 43 0 43"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.436e0b10a79120ac290e8572e200488a.svg";
export { ForwardRef as ReactComponent };